var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);

var MailChimp = function () {
};

MailChimp.prototype.init = function () {

};

module.exports = new MailChimp();
